// La mention « Entreprise » n'est affichée qu'une fois le SIRET validé par l'admin (company_verified)
export const isEntreprise = (u) => u?.profile_type === 'PROFESSIONAL' && !!u?.company_verified;

// Compte déclaré Entreprise dont le SIRET n'a pas encore été validé
export const isEntreprisePending = (u) => u?.profile_type === 'PROFESSIONAL' && !u?.company_verified;
